module.exports = __webpack_public_path__ + "f653de2d156349ad7b7788a7c24c48c3.ttf";